import { transformMarkets } from '../../services/UserGroup.js';
import { APP_CONFIG, getHeaders } from '../constants/global-variables.js';

export async function getLiveMatch(requestId) {

    const url = `${APP_CONFIG.URL.apiBasePath}ajax/livegame/${requestId}`;

    try {
        const res = await axios.get(url, getHeaders());
        const dataTransformed = transformMarkets(res.data);
        return dataTransformed;
    } catch (err) {
    }
}

export async function getLiveStreamLink(stream_id) {
    const url = `${APP_CONFIG.URL.apiBasePath}ajax/livestream/${stream_id}`;
    try {
        const res = await axios.get(url, getHeaders());
        return res.data;
    } catch (err) {
    }
}
